<template>
  <div class="page-layout">
    <div class="columns is-align-items-center margin-0">
      <div class="column is-3-mobile is-5-desktop is-5-widescree p-y-0 p-x-0">
        <div class="level">
          <div class="level-left">
            <div class="page-layout-head">Email Settings</div>
          </div>
        </div>
      </div>
      <div class="column p-y-0 p-x-0 is-flex is-align-items-center header-filters">
        <a class="about-feature" target="_blank"
           href="https://intercom.help/hellopeter/en/articles/4228174-review-invites">
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
      </div>
    </div>
    <hr class="page-layout-horizontal-row">
    <div class="columns invite-menu">
      <div class="column is-12 is-paddingless">
        <div class="tabs is-boxed">
          <ul>
            <li :class="{'is-active': isActiveTab('LookAndFeel')}">
              <router-link to="/collect-reviews/look-and-feel"><span>Look and Feel</span></router-link>
            </li>
<!--            <li :class="{'is-active': isActiveTab('GeneralSettings')}">-->
<!--              <router-link to="/collect-reviews/general-settings"><span>General Settings</span></router-link>-->
<!--            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import misc from '@/mixins/misc.js'

export default {
  name: 'EmailSettingLayout',
  mixins: [misc],
  computed: {
    /**
     * Checking if a user is a paid user
     * @return {boolean}
     */
    isPaidUser () {
      return this.userInfo.subscription.name !== 'Free'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    isActiveTab (tab) {
      return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
    }
  }
}
</script>

<style scoped>
.table td, .table th {
  border: none;
}

.table > tbody > tr {
  background-color: #f5f5f5 !important;
  margin-bottom: 10px;
}

.table > tbody > td {
  margin-bottom: 20px;
}

tr.goto-business {
  cursor: pointer;
}
.tabs li.is-active a {
  color: #2aabe1 !important;
  border-bottom: 2px solid #fff;
}
.invite-menu {
  margin-left: 2px;
  margin-top: 25px
}
.tabs.is-boxed li a {
  font-size: 14px;
  font-weight: normal;
  color: rgba(88, 89, 91, 0.6);
}
.tabs.is-boxed li.is-active a {
  font-weight: bold;
  color: #30aae1;
}
.tabs.is-boxed li {
  width: 125px;
  height: 38px;
  border: solid 1px #ccc;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  background-color: #f5f5f6;
  margin-left: 4px;
  border-bottom: 0px;
}
.tabs.is-boxed li.is-active {
  width: 140px;
  background-color: #ffffff;
  border: solid 2px #fff;
}
.tabs.is-boxed li:nth-child(1){
  margin-left: 0px;
}

.review-invite-head {
  height: 17px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.42;
  text-align: left;
  color: #58595b;
}

.top-horizontal-row {
  margin-left: -33px;
  margin-right: -26px;
}
.is-align-items-center {
  align-items: center;
}
.margin-0 {
  margin: 0;
}
.padding-top-0, .custom-dropdown {
  padding-top: 0;
}
.custom-dropdown {
  max-width: 275px;
  max-height: 37px;
}
>>> .button.button-dropdown img {
  height: 17px !important;
  padding: 0 !important;
}
.page-layout {
  margin-left: 0;
}
.page-layout .page-layout-head {
  color: #58595b;
  font-size: 12px;
}
.header-filters {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/email-settings/EmailSettingLayout.vue